import { render, staticRenderFns } from "./MarketAccounts.vue?vue&type=template&id=3b767679&scoped=true&"
import script from "./MarketAccounts.vue?vue&type=script&lang=js&"
export * from "./MarketAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b767679",
  null
  
)

export default component.exports